module.exports = __webpack_public_path__ + "img/q3.eca421e4.svg";